<main class="main">
    <div class="container">
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Brief Genius Summary Generation Parameter Mapping</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <!-- <div class="form-check ms-2 mt-2 me-2">
                <input class="form-check-input" type="checkbox" id="check1" name="option1" [(ngModel)]="wrapText">
                <label class="form-check-label">Wrap Text</label>
            </div> -->
            <!-- <div class="form-check ms-2 mt-2">
                <input class="form-check-input" type="checkbox" id="includeDisabled" name="includeDisabled"
                    [(ngModel)]="pagination.isDeleted" (change)="GetIncludedisabledRecords()">
                <label class="form-check-label">Include Disabled</label>
            
                <button class="btn btn-primary smallBtn" (click)="GetSummaryParamDataToXLS(pagination)"
                    style="height: 47px !important;">Export
                </button>
            </div> -->


            <div class="d-flex justify-content-end mb-2">
                <div class="form-check ms-2 mt-2">
                    <input class="form-check-input" type="checkbox" id="includeDisabled" name="includeDisabled"
                        [(ngModel)]="pagination.isDeleted" (change)="GetIncludedisabledRecords()">
                    <label class="form-check-label">Include Disabled</label>
                </div>
                <button class="btn btn-primary smallBtn" (click)="GetSummaryParamDataToXLS(pagination)">Export
                </button>
                <button class="btn btn-primary smallBtn" (click)="AddNewRow()">Add New Row</button>
            </div>
            <div class="row m-0">
                <h6 class="text-center" *ngIf="briefGeniusList?.length==0">No records found.</h6>
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px; text-align: center;">
                                <th (click)="SortColumn('Jurisdiction')">
                                    Jurisdiction
                                    <span class="float-right up"
                                        *ngIf="pagination.columnName=='Jurisdiction' && pagination.ascending">
                                        <i class="fa fa-sort-up"></i>
                                    </span>
                                    <span class="float-right down"
                                        *ngIf="pagination.columnName=='Jurisdiction' && !pagination.ascending">
                                        <i class="fa fa-sort-down"></i>
                                    </span>
                                </th>
                                <th (click)="SortColumn('Regulator')">
                                    Regulator
                                    <span class="float-right up"
                                        *ngIf="pagination.columnName=='Regulator' && pagination.ascending">
                                        <i class="fa fa-sort-up"></i>
                                    </span>
                                    <span class="float-right down"
                                        *ngIf="pagination.columnName=='Regulator' && !pagination.ascending">
                                        <i class="fa fa-sort-down"></i>
                                    </span>
                                </th>
                                <th (click)="SortColumn('DocType')">
                                    Doc Type
                                    <span class="float-right up"
                                        *ngIf="pagination.columnName=='DocType' && pagination.ascending">
                                        <i class="fa fa-sort-up"></i>
                                    </span>
                                    <span class="float-right down"
                                        *ngIf="pagination.columnName=='DocType' && !pagination.ascending">
                                        <i class="fa fa-sort-down"></i>
                                    </span>
                                </th>
                                <!-- <th (click)="SortColumn('CreatedOn')">
                                        <i class="fa fa-sort-down"></i>
                                    </span>
                                </th> -->
                                <th>
                                    Action
                                </th>
                            </tr>
                            <!-- Filter row -->
                            <tr>
                                <th>
                                    <form #filterFormJurisdiction (ngSubmit)="SearchBriefGenius('Jurisdiction')">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" [(ngModel)]="filters.jurisdiction"
                                                    name="searchJurisdiction" class="form-control filterSearch"
                                                    placeholder="Search...">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true"
                                                [insideClick]="true">
                                                <button dropdownToggle type="button"
                                                    class="dropdown-toggle filterToggle" title="More options"
                                                    aria-controls="userDropdownBox">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeJurisdiction}">
                                                        <a class="dropdown-item"
                                                            (click)="SearchBriefGenius('Jurisdiction', i)">{{item.name}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th>
                                    <form #filterFormRegulator (ngSubmit)="SearchBriefGenius('Regulator')">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" [(ngModel)]="filters.regulator"
                                                    name="searchRegulator" class="form-control filterSearch"
                                                    placeholder="Search...">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true"
                                                [insideClick]="true">
                                                <button dropdownToggle type="button"
                                                    class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeRegulator}">
                                                        <a class="dropdown-item"
                                                            (click)="SearchBriefGenius('Regulator', i)">{{item.name}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th>
                                    <form #filterFormDocType (ngSubmit)="SearchBriefGenius('DocType')">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" [(ngModel)]="filters.docType" name="searchDocType"
                                                    class="form-control filterSearch" placeholder="Search...">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true"
                                                [insideClick]="true">
                                                <button dropdownToggle type="button"
                                                    class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeDocType}">
                                                        <a class="dropdown-item"
                                                            (click)="SearchBriefGenius('DocType', i)">{{item.name}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <!-- <th>
                                    <form #filterFormCreatedOn (ngSubmit)="SearchBriefGenius('CreatedOn')">
                                        <div class="form-floating">
                                            <input type="date" [(ngModel)]="filters.createdOn" name="searchCreatedOn"
                                                class="form-control filterSearch" placeholder="Search...">
                                            <label>Search</label>
                                        </div>
                                    </form>
                                </th> -->
                                <th>
                                    
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let newRow of newRows; let i = index">
                                <td>
                                    <!-- <select [(ngModel)]="newRow.JurisdictionID" class="form-select">
                                        <option *ngFor="let j of jurisdictionDropdown" [value]="j.JurisdictionID">
                                            {{j.Jurisdiction}}</option>
                                    </select> -->
                                    <ng-select 
                                        [(ngModel)]="newRow.JurisdictionID"
                                        [items]="jurisdictionDropdown"
                                        bindLabel="Jurisdiction"
                                        bindValue="JurisdictionID"
                                        [searchable]="true"
                                        [clearable]="true"
                                        [appendTo]="'body'">
                                    </ng-select>
                                </td>
                                <td>
                                    <!-- <select [(ngModel)]="newRow.RegulatorID" class="form-select">
                                        <option *ngFor="let r of regulatorDropdown" [value]="r.RegulatorID">
                                            {{r.RegulatorName}}</option>
                                    </select> -->
                                    <ng-select 
                                        [(ngModel)]="newRow.RegulatorID"
                                        [items]="regulatorDropdown"
                                        bindLabel="RegulatorName"
                                        bindValue="RegulatorID"
                                        [searchable]="true"
                                        [clearable]="true"
                                        [appendTo]="'body'">
                                    </ng-select>
                                </td>
                                <td>
                                    <!-- <select [(ngModel)]="newRow.DocTypeID" class="form-select">
                                        <option *ngFor="let d of docTypeDropdown" [value]="d.DocTypeID">
                                            {{d.DocTypeName}}</option>
                                    </select> -->
                                     <ng-select 
                                        [(ngModel)]="newRow.DocTypeID"
                                        [items]="docTypeDropdown"
                                        bindLabel="DocTypeName"
                                        bindValue="DocTypeID"
                                        [searchable]="true"
                                        [clearable]="true"
                                        [appendTo]="'body'">
                                    </ng-select>
                                </td>
                                <!-- <td>
                                    <input type="date" [(ngModel)]="newRow.CreatedOn" class="form-control" />
                                </td> -->
                                <td style="width:5%;" class="td-actions">
                                    <a title="Click here to Save" (click)="SaveNewRow(i)">
                                            <i class="fa fa-save"></i>
                                    </a>
                                    <a title="Click here to Cancel" (click)="RemoveNewRow(i)">
                                            <i class="fa fa-trash"></i>
                                    </a>
                                    <!-- <button class="btn btn-sm" (click)="SaveNewRow(i)">
                                        <i class="fa fa-save me-1"></i>
                                    </button>
                                    <button class="btn btn-sm" (click)="RemoveNewRow(i)">
                                        <i class="fa fa-trash me-1"></i>
                                    </button> -->
                                </td>
                            </tr>
                            <tr *ngIf="briefGeniusList?.length==0">
                                <td colspan="4" class="text-center" style="padding-bottom: 137px;"></td>
                            </tr>
                            <tr *ngFor="let data of briefGeniusList;  let i = index">
                                <!-- <td title="{{data?.Jurisdiction}}" class="ellipsis">{{data?.Jurisdiction}}</td> -->
                                 <td>
                                    <ng-container *ngIf="editRowIndex === i; else viewJurisdiction">
                                        <ng-select
                                            [(ngModel)]="editModel.JurisdictionID"
                                            [items]="jurisdictionDropdown"
                                            bindLabel="Jurisdiction"
                                            bindValue="JurisdictionID"
                                            [appendTo]="'body'">
                                        </ng-select>
                                    </ng-container>

                                    <ng-template #viewJurisdiction>
                                        <!-- {{data.Jurisdiction}} -->
                                        {{ getJurisdictionName(data.JurisdictionID) }}
                                    </ng-template>
                                </td>

                                <!-- <td title="{{data?.Regulator}}" class="ellipsis">{{data?.Regulator}}</td> -->
                                 <td>
                                    <ng-container *ngIf="editRowIndex === i; else viewRegulator">
                                        <ng-select
                                            [(ngModel)]="editModel.RegulatorID"
                                            [items]="regulatorDropdown"
                                            bindLabel="RegulatorName"
                                            bindValue="RegulatorID"
                                            [appendTo]="'body'">
                                        </ng-select>
                                    </ng-container>

                                    <ng-template #viewRegulator>
                                        <!-- {{data.Regulator}} -->
                                        {{ getRegulatorName(data.RegulatorID) }}
                                    </ng-template>
                                </td>

                                <!-- <td title="{{data?.DocType}}" class="ellipsis">{{data?.DocType}}</td> -->
                                <td>
                                    <ng-container *ngIf="editRowIndex === i; else viewDocType">
                                        <ng-select
                                            [(ngModel)]="editModel.DocTypeID"
                                            [items]="docTypeDropdown"
                                            bindLabel="DocTypeName"
                                            bindValue="DocTypeID"
                                            [appendTo]="'body'">
                                        </ng-select>
                                    </ng-container>

                                    <ng-template #viewDocType>
                                        <!-- {{data.DocType}} -->
                                        {{ getDocTypeName(data.DocTypeID) }}
                                    </ng-template>
                                </td>
                                <!-- <td title="{{data?.CreatedOn | date:'yyyy-MM-dd'}}" class="ellipsis">{{data?.CreatedOn |
                                                                date:'yyyy-MM-dd'}}</td> -->
                                <td style="width:5%;" class="td-actions">
                                    <!-- <a title="Click here to activate" *ngIf=" data?.IsActive==0" (click)="ShowConfirmBox(data,false)">
                                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                                    </a>
                                    <a title="Click here to delete" *ngIf=" data?.IsActive==1"
                                            (click)="ShowConfirmBox(data,true)">
                                            <i class="fa fa-trash"></i>
                                    </a> -->
                                        <ng-container *ngIf="editRowIndex !== i">
                                            <a title="Edit" (click)="editRow(i, data)">
                                                <i class="fa fa-edit"></i>
                                            </a>

                                            <a title="Click here to activate" *ngIf=" data?.IsActive==0" (click)="ShowConfirmBox(data,false)">
                                                <i class="fa fa-check-circle"></i>
                                            </a>

                                            <a title="Click here to delete" *ngIf=" data?.IsActive==1" (click)="ShowConfirmBox(data,true)">
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </ng-container>
                                        <ng-container *ngIf="editRowIndex === i">
                                            <a title="Save" (click)="saveRow(i)">
                                                <i class="fa fa-save"></i>
                                            </a>

                                            <a title="Cancel" (click)="cancelEdit(i)">
                                                <i class="fa fa-times"></i>
                                            </a>
                                        </ng-container>
                                </td>
                            </tr>
                            <tr *ngIf="(briefGeniusList?.length || 0) <= 4 && (briefGeniusList?.length || 0) != 0">
                                <td colspan="4" class="text-center" style="padding-bottom: 137px;"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Pagination -->
            <div class="row clear-fix col-12 mt-2">
                <div class="col-3 ps-4 d-flex">
                    <div class="form-floating p-1">
                        <select class="form-select form-control paginationDropdown" [(ngModel)]="pagination.pageLength"
                            (change)="GetBriefGeniusByPageLength()">
                            <option value="100">100</option>
                            <option value="300">300</option>
                            <option value="500">500</option>
                            <option value="700">700</option>
                            <option value="1000">1000</option>
                            <option value="1250">1250</option>
                        </select>
                    </div>
                    <label class="mt-2 pt-2 ms-2">Items per page</label>
                </div>
                <div class="col-9 m-0 float-right">
                    <div class="row p-0">
                        <div class="col-4 mt-3 p-0" style="text-align: center;">
                            <h6 *ngIf="totalRecordsForPagination!=0">{{totalRecordsForPagination}} items found
                            </h6>
                        </div>
                        <div class="col-8 p-0 m-0" *ngIf="totalPages>1">
                            <app-pagination [totalPages]="totalPages" [currentPage]="currentPage"
                                (pageChanged)="GetBriefGenius($event)">
                            </app-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
<app-loader [showLoader]="showLoader"></app-loader>
<notifier-container></notifier-container>